<template>
<div>
  <div class="row">
    <div v-if="loading" class="col-md-4 login spinspin">
    </div>
  </div>
  <form @submit.prevent="sendRequest" autocomplete="off">
    <div v-if="!loading" class="row">
        <div class="col-md-4 login">
          <h6>Current Password</h6>
            <div class="alert alert-danger" v-if="error">
              <p>{{ error }}</p>
            </div>
            <div class="form-group">
              <input type="password" class="form-control" placeholder="Enter your current Password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,}" title="Must contain at least one number and one uppercase and lowercase letter, and at least 12 or more characters" v-model="credentials.oldPassword">
            </div>
        <div>
          <h6>New Password</h6>
            <div class="alert alert-danger" v-if="error">
              <p>{{ error }}</p>
            </div>
            <div class="form-group">
              <input type="password" class="form-control" id="NewPassword" placeholder="Enter your new Password" v-model="credentials.newPassword" @focus="passwordDiv_OnFocus()" @blur="passwordDiv_OnBlur()" @keyup="password_OnKeyUp()">
            </div>
        </div>
        <div>
          <h6>Repeat Password</h6>
            <div class="alert alert-danger" v-if="error">
              <p>{{ error }}</p>
            </div>
            <div class="form-group">
              <input type="password" class="form-control" id="RepeatNewPassword" placeholder="Repeat your new Password" v-model="notneeded.repeatPassword" @focus="passwordDiv_OnFocus()" @blur="passwordDiv_OnBlur()" @keyup="passwordRepeat_OnKeyUp()">
            </div>
        </div>
        <div id="passwordMessage" class="row hideMe">
          <div class="col-md-10">
          <h3>Password must contain the following:</h3>
          <p id="lowerLetter_PWD" class="invalid">A <b>lowercase</b> letter</p>
          <p id="upperLetter_PWD" class="invalid">A <b>capital (uppercase)</b> letter</p>
          <p id="number_PWD" class="invalid">A <b>number</b></p>
          <p id="specialChar_PWD" class="invalid">A <b>special character</b></p>
          <p id="length_PWD" class="invalid">Minimum <b>12 characters</b></p>
          <p id="repeatValidation_PWD" class="invalid">Repeat password must <b>match</b> new password</p>
          </div>
        </div>
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" type="submit">Reset Password</button>
        </div>
    </div></div>
  </div>
  </form>
  <b-modal id="modalFailure" title="Thank you for contacting us" hide-footer @hide="modalClose">
    <h4 :class='sentClass'>{{message}}</h4>
  </b-modal>
  <b-modal id="modalSuccess" title="Thank you for contacting us" hide-footer @hide="modalClose_Success">
    <h4 :class='sentClass'>{{message}}</h4>
  </b-modal>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import auth from './auth'
export default {
  name: 'changePassword',
  data: function () {
    return {
      credentials: {},
      notneeded: {},
      sendPasswords: {},
      error: '',
      message: '',
      sentClass: '',
      loading: false,
      setHeaders: ''.toLowerCase,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    sendRequest () {
      if (this.credentials.newPassword === this.notneeded.repeatPassword) {
        this.loading = true
        this.sendPasswords = btoa(this.credentials.oldPassword + ':' + this.credentials.newPassword)
        let uri = this.apiUrl + auth.user.clientID + '/changepassword'
        axios.post(uri, '',
          {
            headers: auth.getAuthHeader1(this.sendPasswords)
          }).then((response) => {
          this.message = 'You have successfully changed your password'
          this.sentClass = 'text-success'
          this.$root.$emit('bv::show::modal', 'modalSuccess')
        }).catch(error => {
          console.log(error.response)
          this.loading = true
          this.message = 'Something went wrong, and your password was not sent. Reason: ' + error.response.data
          this.sentClass = 'text-danger'
          this.$root.$emit('bv::show::modal', 'modalFailure')
        })
      } else {
        this.loading = true
        this.message = 'Please make sure the new password and confirmation match'
        this.sentClass = 'text-danger'
        this.$root.$emit('bv::show::modal', 'modalFailure')
      }
    },
    modalClose () {
      this.loading = false
      this.credentials = {}
    },
    modalClose_Success () {
      this.loading = false
      this.credentials = {}
      this.$router.push('/contracts')
    },
    passwordDiv_OnFocus () {
      document.getElementById('passwordMessage').classList.remove('hideMe')
      document.getElementById('passwordMessage').classList.add('showMe')
    },
    passwordDiv_OnBlur () {
      document.getElementById('passwordMessage').classList.remove('showMe')
      document.getElementById('passwordMessage').classList.add('hideMe')
    },
    password_OnKeyUp () {
      /* Regex expressions */
      var arrLowerCaseLetters = /[a-z]/g
      var arrUpperCaseLetters = /[A-Z]/g
      var arrNumbers = /[0-9]/g
      var arrSpecialCaseCharacters = /[(!#$%&*@\\)+]/g

      /* HTML inputs */
      var passwordInput = document.getElementById('NewPassword')
      
      /* Validation HTML */
      var lowerLetterHTML = document.getElementById('lowerLetter_PWD')
      var upperLetterHTML = document.getElementById('upperLetter_PWD')
      var numberHTML = document.getElementById('number_PWD')
      var specialCharHTML = document.getElementById('specialChar_PWD')
      var lengthHTML = document.getElementById('length_PWD')

      /* Does the password have one lowercase? */
      if (passwordInput.value.match(arrLowerCaseLetters)) {
        lowerLetterHTML.classList.remove('invalid')
        lowerLetterHTML.classList.add('valid')
      }
      else {
        lowerLetterHTML.classList.remove('valid')
        lowerLetterHTML.classList.add('invalid')
      }

      /* Does the password have one uppercase? */
      if (passwordInput.value.match(arrUpperCaseLetters)) {
        upperLetterHTML.classList.remove('invalid')
        upperLetterHTML.classList.add('valid')
      } else {
        upperLetterHTML.classList.remove('valid')
        upperLetterHTML.classList.add('invalid')
      }

      /* Does the password have one number? */
      if (passwordInput.value.match(arrNumbers)) {
        numberHTML.classList.remove('invalid')
        numberHTML.classList.add('valid')
      } else {
        numberHTML.classList.remove('valid')
        numberHTML.classList.add('invalid')
      }

      /* Does the password have one special char? */
      if (passwordInput.value.match(arrSpecialCaseCharacters)) {
        specialCharHTML.classList.remove('invalid')
        specialCharHTML.classList.add('valid')
      } else {
        specialCharHTML.classList.remove('valid')
        specialCharHTML.classList.add('invalid')
      }

      /* Is the password a minimum of 12 length? */
      if (passwordInput.value.length >= 12) {
        lengthHTML.classList.remove('invalid')
        lengthHTML.classList.add('valid')
      } else {
        lengthHTML.classList.remove('valid')
        lengthHTML.classList.add('invalid')
      }

      this.passwordRepeat_OnKeyUp()
    },
    passwordRepeat_OnKeyUp () {
      var passwordInput = document.getElementById('NewPassword')
      var repeatPasswordInput = document.getElementById('RepeatNewPassword')

      var repeatValidationHTML = document.getElementById('repeatValidation_PWD')

      if (passwordInput.value === repeatPasswordInput.value) {
        repeatValidationHTML.classList.remove('invalid')
        repeatValidationHTML.classList.add('valid')
      } else {
        repeatValidationHTML.classList.remove('valid')
        repeatValidationHTML.classList.add('invalid')
      }
    }
  }
}
</script>

<style>
.invalid {
  color:red
}

.invalid:before {
  position: relative;
  left: -35px;
  content: "\2717";
}

.valid {
  color:green
}

.valid:before {
  position: relative;
  left: -35px;
  content: "\2713";
}

.hideMe {
  display: none;
}

.showMe {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/changePW.vue